import React from "react"
import { faSpinner } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function LoadingComponent() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <br />
      <br />
      <FontAwesomeIcon icon={faSpinner} size={"2x"} spin />
    </div>
  )
}
